import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SectionTitle from "../../common/SectionTitle/SectionTitle";
import ListCard from "../../cards/ListCard/ListCard";
import listCardsData from "../../../data/listCardsData";
import './HomeHighlightSectionOne.css'

import HighlightBannerOne from '../../../assets/images/banner-1.png'

export default function HomeHighlightSectionOne() {
    return (
        <section>
            <Container fluid>
                <Row>
                    <Col md={6}>
                        <img src={HighlightBannerOne} className="highlightBannerOne rounded-2 mb-md-2" />
                    </Col>

                    <Col md={6}>
                        <SectionTitle
                            subtitle="Reliability"
                            title="You Can Trust"
                            align="left"
                        />
                        <p class="brand-section-desc">When your business depends on transportation, reliability is everything.</p>

                        {listCardsData.map((item) => (
                            <Col key={item.id} lg={12}>
                                <ListCard
                                    icon={item.icon}
                                    title={item.title}
                                    description={item.description}
                                />
                            </Col>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}